import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Paginated } from '@rms/sdk';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { WidgetCreateRequest, WidgetResponse, WidgetUpdateRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class WidgetsApiService {
  private readonly http = inject(HttpClient);

  public getWidgets(page = 0, size = 20): Observable<Paginated<WidgetResponse>> {
    const params = new HttpParams().append('page', page).append('size', size);

    return this.http.get<Paginated<WidgetResponse>>(`${environment.apiEndpoint}/v1/widgets`, { params });
  }

  public getWidget(id: string): Observable<WidgetResponse> {
    return this.http.get<WidgetResponse>(`${environment.apiEndpoint}/v1/widgets/${id}`);
  }

  public createWidget(request: WidgetCreateRequest): Observable<WidgetResponse> {
    return this.http.post<WidgetResponse>(`${environment.apiEndpoint}/v1/widgets`, request);
  }

  public updateWidget(id: string, request: WidgetUpdateRequest): Observable<WidgetResponse> {
    return this.http.put<WidgetResponse>(`${environment.apiEndpoint}/v1/widgets/${id}`, request);
  }

  public deleteWidget(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiEndpoint}/v1/widgets/${id}`);
  }
}
